import { EXP_VAR_TREATMENT, ExperimentNames } from 'common/experiments/ExperimentDefinitions';
import { isNil } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useVariant } from 'src/experimentation/useVariant';
import { useFeatureFlag } from 'src/feature-flags/consumers';
import { EXPERIMENT_REGISTRY } from './experimentRegistry';

export interface ExperimentResult {
  isTreatment: boolean;
  isEligible: boolean;
  logExposure: () => void;
}

export function useExperiment(name: ExperimentNames): ExperimentResult {
  const definition = EXPERIMENT_REGISTRY[name];
  const treatmentVariant = definition?.treatmentVariant ?? EXP_VAR_TREATMENT;

  const rawFlag = useFeatureFlag(definition?.flagName);
  // if an experiment has no feature flag, then it should be default on
  const experimentEnabled = isNil(definition?.flagName) ? true : rawFlag;

  const { variant, logExposure: logVariantExposure } = useVariant(name, definition?.logExposureImmediately ?? false);

  const isTreatment = experimentEnabled && variant?.name === treatmentVariant;
  const isEligible = experimentEnabled && variant !== null;

  const logExposure = useCallback(() => {
    if (experimentEnabled) {
      logVariantExposure();
    }
  }, [experimentEnabled, logVariantExposure]);

  return useMemo(() => ({ isTreatment, isEligible, logExposure }), [isTreatment, isEligible, logExposure]);
}
